import {setHttpData} from '@config/makeRequest'

/**
 * 普华永道获取是否在考试时间内、做题次数
 */
export const getPwcExamInfo = (params) => {
    return new Promise((resolve, reject) => {
        setHttpData('/qzCloud/getExamDateAndExamNum', params)
        .then(res => {
            if (res.success) {
                resolve(res.result)
            } else {
                reject({msg: res.errorMsg || '考试信息获取失败'})
            }
        }).catch(() => {
            reject({msg: '考试信息获取失败'})
        })
    })
}


/**
 * 获取是否有临时保存试卷
 */
export const checkTempActivityExamPaper = (params) => {
    return new Promise((resolve, reject) => {
        setHttpData('/exam/checkTempActivityExamPaper', params)
        .then(res => {
            if (res.success) {
                const {result} = res
                resolve(result)
            } else {
                reject({msg: '获取临时保存信息失败'})
            }
        }).catch(() => {
            reject({msg: '获取临时保存信息失败'})
        })
    })
}

/**
 * 税务局等机考入口 pwcList
 */
export const getExamConfigListByCwareIDApi = (params) => {
    return new Promise((resolve, reject) => {
        setHttpData('/qzCloud/getExamConfigListByCwareID', params)
        .then(res => {
            if (res.success) {
                const {result} = res
                resolve(result)
            } else {
                reject({msg: '获取列表信息失败'})
            }
        }).catch(() => {
            reject({msg: '获取列表信息失败'})
        })
    })
}

//获取是否有临时保存试卷---活动的临时保存检测
export const checkIsHasTempRecordActivityReq = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/m/checkIsHasTempRecordActivity', params)
      .then(res => {
        if (res.success) {
          const result = res.result
          resolve(result)
        } else {
          reject({ msg: '获取临时保存信息失败' })
        }
      }).catch(() => {
      reject({ msg: '获取临时保存信息失败' })
    })
  })
}

//检测是否已经做了，已做返回分数---活动
export const checkPaperViewIsDoneActivityReq = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/checkPaperViewIsDoneMidActivity', params)
      .then(res => {
        if (res.success) {
          const {result = {}} = res;
          resolve(result)
        } else {
          reject({ msg: '检测是否已做失败' })
        }
      }).catch(() => {
      reject({ msg: '检测是否已做失败' })
    })
  })
}

//检查闯关活动的体力值
export const dealMyChanceWG = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/passPoint/dealMyChanceWG', params,null ,true)
      .then(res => {
        if (res.success) {
          const {result = {}} = res;
          resolve(result)
        } else {
          reject({ msg: '检测是否已做失败' })
        }
      }).catch(() => {
      reject({ msg: '检测是否已做失败' })
    })
  })
}
